import React from 'react';

import Input from '../Input';
import { StyledCalendarIcon } from './styles';

export default function DatePicker({
  disabled,
  placeholder = 'Selecione uma data',
  containerStyle,
  onChange,
  onBlur,
  label,
  value,
  error,
  withTime = false,
}) {
  return (
    <Input
      label={label}
      icon={<StyledCalendarIcon />}
      guide={false}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onChange={onChange}
      error={error}
      containerStyle={containerStyle}
      onBlur={onBlur}
      masked
      mask={
        withTime
          ? [
              /[0-9]/,
              /[0-9]/,
              '/',
              /[0-9]/,
              /[0-9]/,
              '/',
              /[0-9]/,
              /[0-9]/,
              /[0-9]/,
              /[0-9]/,
              ' ',
              /[0-9]/,
              /[0-9]/,
              ':',
              /[0-9]/,
              /[0-9]/,
            ]
          : [
              /[0-9]/,
              /[0-9]/,
              '/',
              /[0-9]/,
              /[0-9]/,
              '/',
              /[0-9]/,
              /[0-9]/,
              /[0-9]/,
              /[0-9]/,
            ]
      }
    />
  );
}
